import { ref } from 'vue'
import { defineStore } from 'pinia'
import { useAuth } from '@/stores/auth'
import { useRouter } from 'vue-router'

export const useAssessmentPopupStore = defineStore('assessmentPopup', () => {
  const isVisible = ref(false)
  const showExitAssessment = ref(false)
  const showInitialAssessment = ref(false)
  // Add a state to control the EndRoundWidget visibility
  const shouldHideEndRoundWidget = ref(false)
  const router = useRouter()

  const popupProps = ref({
    playerId: '',
    playerEmail: '',
    url: 'story',
    slide: undefined as number | undefined
  })

  const show = (props: {
    playerId: string
    playerEmail?: string
    url?: string
    slide?: number
  }) => {
    popupProps.value = {
      playerId: props.playerId,
      playerEmail: props.playerEmail || '',
      url: props.url || 'story',
      slide: props.slide
    }
    isVisible.value = true
    shouldHideEndRoundWidget.value = true
  }

  const close = () => {
    isVisible.value = false
    showExitAssessment.value = false
    showInitialAssessment.value = false
  }

  const showAssessment = () => {
    const { player } = useAuth()
    if (!player?.email) {
      showExitAssessment.value = true
    } else {
      router.push({ name: 'home2' })
    }
  }

  const showCompletionAssessment = () => {
    const { player } = useAuth()
    if (!player?.email) {
      showInitialAssessment.value = true
    } else {
      router.push({ name: 'home2' })
    }
  }

  const resetEndRoundWidgetState = () => {
    shouldHideEndRoundWidget.value = false
  }

  return {
    isVisible,
    showExitAssessment,
    showInitialAssessment,
    shouldHideEndRoundWidget,
    popupProps,
    show,
    close,
    showAssessment,
    showCompletionAssessment,
    resetEndRoundWidgetState
  }
})
